import React, { useEffect, useState } from "react"
import { Alert, Button, TableColumnsType, Typography } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useRegister } from "../../../contexts/RegisterContext"
import RegisterView from "../RegisterView"
import { useConfig } from "../../../contexts/ConfigContext"
import { useCompany } from "../../../contexts/CompanyContext"
import { useItems, useMovements } from "../../../hooks/useInventory"
import useAuth from "../../../hooks/useAuth"
import { movementStatus } from "../../../config/const"
import SelectMovementType from "../../common/SelectMovementType"
import { useUser } from "../../../contexts/UserContext"
import { textNumberFormater } from "../../../utils"

const { Text } = Typography

function ViewRegisterExit(){
  const {register,updateRegister} = useRegister()
  const {config} = useConfig()
  const {company} = useCompany()
  const {user} = useUser()
  const [spinning,setSpinning] = useState(true)
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:mvData, mutate: mutateMovements} = useMovements(tokenData,{
    company:company.current?.uid,
    module:config.module,
    first: true,
    createdBy: user.document_number,
    status:movementStatus.PENDING,
    documentType: register.currentMovementType
  })
  const {data:itData} = useItems(tokenData,{
    company:company.current?.uid,
    module:config.module
  })

  useEffect(() => {
    if (tokenData?.key && company.current?.uid && register.currentMovementType) {
      mutateMovements();
    }
  }, [register.currentMovementType]);

  useEffect(()=>{
    if(tokenData && mvData?.movement){
      setSpinning(false)
      const serverMovement = mvData.movement
      if(serverMovement?.uid){
        const isResumedDifferentPending = 
          register.currentPending?.uid && 
          register.currentPending.uid !== serverMovement.uid &&
          register.currentPending.document_type === register.currentMovementType

        const activePending = isResumedDifferentPending 
          ? register.currentPending 
          : serverMovement

        const itemListExits = activePending.item_list || []
        console.log("entries:", itemListExits)
        updateRegister({itemListExits,currentPending: activePending})
      }else if(register.currentPending?.uid && register.currentPending.document_type === register.currentMovementType){
        const itemListExits = register.currentPending.item_list || []
        updateRegister({itemListExits,currentPending: register.currentPending})
      }else if(!register.currentPending?.uid){
        updateRegister({itemListExits:[]})
      }
    } else if (mvData && !mvData.movement) {
      setSpinning(false)
      if (!register.currentPending?.uid) {
        updateRegister({itemListExits:[]})
      }
    }
    if(tokenData && itData?.itemList){
      updateRegister({registerList:itData.itemList})
    }
  },[tokenData,mvData,itData,register.currentMovementType])

  const columnsExit:TableColumnsType = [
    {title:"#",dataIndex:"register"},
    {title:"ID",dataIndex:"code"},
    {title:"Nombre",dataIndex:"name"},
    {title:"Presentación",dataIndex:"display"},
    {title:"Cantidad",dataIndex:"quantity"},
    {title:"Total",dataIndex:"client_amount",render:(text: any)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
  ]

  let subTotal = 0
  const columnsData = columnsExit
  const currentMovementType = register.movementTypesExit.find(el => el.key === register.currentMovementType)
  if(!register.currentMovementType || !currentMovementType){
    return <SelectMovementType />
  }

  const footerElement = () => (
    <Button 
      type="primary" 
      icon={<PlusOutlined />} 
      onClick={() => updateRegister({ showAddItem: true })}
    >
      Añadir Elemento
    </Button>
  )
  const title = `Registrar ${currentMovementType.string_value}`

  const isQuotation = register.currentMovementType === "QUOTATION"

  const topBanner = isQuotation ? (
    <Alert
      message={<Text strong style={{ fontSize: 13 }}>Propuesta Comercial / Cotización</Text>}
      description="Esta cotización formaliza una propuesta de precios y condiciones para el cliente. No descuenta ni afecta las existencias físicas en bodega."
      type="info"
      showIcon
      closable
      style={{ marginBottom: 16, borderRadius: 8 }}
    />
  ) : null

  const itemList = register.itemListExits?.map((el)=>{
    const client_amount = el.total_amount_net || el.total_amount_full || 0
    subTotal += client_amount 
    const code = el.custom_id || el.key || el.uid
    return {
      ...el,
      code,
      client_amount,
    }
  }) || []

  const addPending = (acept:boolean) => {
    if(register.itemListExits.length === 0){
      return alert("Debe añadir elementos al registro")
    }
    if(acept){
      updateRegister({showCreateMovement: true})
    }else{
      updateRegister({itemListExits: []})
    }
  }

  const handleClick = (data:any)=>{
    console.log("Click en:",data)
    updateRegister({showAddItem:true,currentMovementItem:data})
  }

  const headerElement = () => 
  <div style={{display:"flex",justifyContent:"flex-end"}}>
    <Button 
      type="link" 
      onClick={()=>updateRegister({currentMovementType:null})}
    >
      {`Cambiar tipo - ${currentMovementType.string_value}`}
    </Button>
  </div> 
  
  return (
    <RegisterView
      title={title}
      topBanner={topBanner}
      spinning={spinning}
      columnsData={columnsData} 
      itemList={itemList}
      subTotal={subTotal}
      footerElement={footerElement}
      addPending={addPending}
      headerElement={headerElement}
      actionButtonText={isQuotation ? "Generar Cotización" : "Facturar"}
      onRow={(data:any)=>{return {onClick:()=>handleClick(data),style:{cursor:"pointer"}}}}>
    </RegisterView>
  )
}

export default ViewRegisterExit